/**
 * sl-n8i1.5: WorkflowGateProvider
 * sl-y2po.12: Plan-Based Feature Gate Integration
 * sl-za0v: Simplified — no more checkStatus() call (SWR needs no provisioning)
 *
 * Provider component that:
 * 1. Reads plan-based workflow availability from FeatureGateContext
 * 2. Toggles body.workflow-enabled class for Lit toolbar consumers
 *
 * Mount inside FeatureGateProvider at workspace scope.
 */

import { type ReactNode, useEffect } from 'react';

import {
  FEATURE_KEY_WORKFLOW,
  useFeatureGate,
} from '../hooks/use-feature-gate';
import { WORKFLOW_ENABLED_CLASS } from '../hooks/use-workflow-gate';

interface WorkflowGateProviderProps {
  children: ReactNode;
}

/**
 * Provider that manages global workflow engine state.
 * Reads plan access from the unified /features endpoint via FeatureGateContext.
 */
export function WorkflowGateProvider({ children }: WorkflowGateProviderProps) {
  const { isFeatureAllowed } = useFeatureGate();

  // sl-za0v: Plan gate only — SWR needs no provisioning/connectivity check
  const isEnabled = isFeatureAllowed(FEATURE_KEY_WORKFLOW);

  // Toggle body class for Lit components
  useEffect(() => {
    document.body.classList.toggle(WORKFLOW_ENABLED_CLASS, isEnabled);

    return () => {
      document.body.classList.remove(WORKFLOW_ENABLED_CLASS);
    };
  }, [isEnabled]);

  return <>{children}</>;
}
